import {command, queryAll} from "../utils/api";

const GET_REGULATORY_REPORTING_TYPES_URL = `${process.env.PUBLIC_URL}/api/v1/r/regulatoryReportingTypes`;
export const GET_REGULATORY_REPORTING_TYPES = 'GET_REGULATORY_REPORTING_TYPES';
export const GET_REGULATORY_REPORTING_TYPES_COMPLETED = 'GET_REGULATORY_REPORTING_TYPES_COMPLETED';
export const GET_REGULATORY_REPORTING_TYPES_FAILED = 'GET_REGULATORY_REPORTING_TYPES_FAILED';

export function getRegulatoryReportingTypes() {
  return queryAll(GET_REGULATORY_REPORTING_TYPES_URL, {order: 'name ASC'}, GET_REGULATORY_REPORTING_TYPES,
    GET_REGULATORY_REPORTING_TYPES_COMPLETED, GET_REGULATORY_REPORTING_TYPES_FAILED);
}

const ADD_REGULATORY_REPORTING_TYPE_URL = `${process.env.PUBLIC_URL}/api/v1/regulatoryReportingType/add`;
export const ADD_REGULATORY_REPORTING_TYPE = 'ADD_REGULATORY_REPORTING_TYPE';
export const ADD_REGULATORY_REPORTING_TYPE_COMPLETED = 'ADD_REGULATORY_REPORTING_TYPE_COMPLETED';
export const ADD_REGULATORY_REPORTING_TYPE_FAILED = 'ADD_REGULATORY_REPORTING_TYPE_FAILED';

export const addRegulatoryReportingType = command(ADD_REGULATORY_REPORTING_TYPE_URL, ADD_REGULATORY_REPORTING_TYPE,
  ADD_REGULATORY_REPORTING_TYPE_COMPLETED, ADD_REGULATORY_REPORTING_TYPE_FAILED);



// WEBPACK FOOTER //
// ./src/RegulatoryReporting/actions.js